import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    width: "100%",
    flexDirection: "column",
    boxSizing: "border-box",
    gap: "16px",
    borderBottom: "none",
  },
  paper: {
    display: "flex",
    justifyContent: "space-between",
    flexDirection: "column",
    background: "#F9FAFA",
    boxShadow: "none",
    padding: theme.spacing(3, 2),
    gap: 16,
  },
  label: {
    color: "#5F6164",
    fontSize: 14,
    marginBottom: 4,
    textTransform: "capitalize",
  },
  headBox: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: 8,
  },
  leftBox: {
    display: "flex",
    gap: 8,
    alignItems: "flex-end",
  },
  rightBox: {
    display: "flex",
    gap: 8,
    justifyContent: "flex-end",
    alignItems: "flex-end",
  },
  searchBox: {},
  filterIconBtn: {
    "& .MuiTypography-root": {
      display: "none",
    },
    "& .MuiButton-root": {
      minWidth: 40,
      padding: 8,
    },
  },
  statsSection: {
    display: "flex",
    margin: theme.spacing(0, 2),
    gap: theme.spacing(2),
  },
  statsContainer: {
    flexGrow: 1,
    background: "#F9FAFA",
    padding: theme.spacing(2, 3),
    borderRadius: 8,
  },
  titleBox: {
    display: "flex",
    gap: 8,
  },
  statsBox: {
    marginTop: 8,
    display: "flex",
    gap: "10px 64px",
    flexWrap: "wrap",
  },
  statsTitle: {
    fontSize: 18,
    fontWeight: 500,
  },
  contentBox: {
    position: "relative",
    display: "flex",
    flexDirection: "column",
    margin: theme.spacing(0, 2),
    maxHeight: "calc(100vh - 210px)",
    overflow: "scroll",
  },
  tableContainer: {
    scrollbarWidth: "none",
    display: "inline-block",
    width: "auto",
    maxWidth: "none",
    overflow: "auto",
    position: "relative",
    boxShadow: "none",
    borderRight: "1px solid #BEBFC0",
    maxHeight: "calc(100vh - 498px)",
    boxSizing: "border-box",
  },
  tableContainer2: {
    display: "inline-block",
    flex: 1,
    overflow: "auto",
    position: "relative",
    boxShadow: "none",
    border: "none",
    maxHeight: "calc(100vh - 490px)",
    boxSizing: "border-box",
  },
  tableHeadCell: {
    padding: "14px 0",
    background: "#F9FAFA",
    borderBottom: "1px solid #BEBFC0",
  },
  tableHeadCheckCell: {
    background: "#F9FAFA",
    borderBottom: "1px solid #BEBFC0",
    textAlign: "center",
    padding: "14px 22px",
  },
  tableHeadLabel: {
    fontWeight: 600,
    whiteSpace: "nowrap",
  },
  tableCell: {
    background: "#F9FAFA",
    padding: "14px 22px",
    whiteSpace: "nowrap",
    borderBottom: "1px solid #BEBFC0",
  },
  activeRow: {
    background: "#0129FA1A",
  },
  selectCheckbox: {
    "&.MuiCheckbox-colorSecondary.Mui-checked": {
      color: "#0129FA",
    },
  },
  noteCell: {
    display: "flex",
    justifyContent: "center",
  },
  tableCellContent: {
    padding: "0 22px",
    borderLeft: "1px solid #E0E0E0",
  },
  fixedHeight: {
    height: 50,
  },
  tableFooter: {
    borderTop: "1px solid #BEBFC0",
    width: "100%",
    height: 64,
    padding: theme.spacing(1, 0),
    position: "sticky",
    background: "#F9FAFA",
    zIndex: 1,
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    bottom: 0,
  },
  "@media (max-width: 1280px)": {
    leftBox: {
      flex: 1,
      minWidth: 0,
    },
    searchBox: {
      flex: 1,
      minWidth: 140,
      maxWidth: 220,
      "& > *": {
        width: "100%",
      },
    },
  },
  "@media (max-width: 840px)": {
    paper: {
      gap: 16,
    },
    headBox: {
      width: "100%",
    },
    leftBox: {
      width: "100%",
    },
    rightBox: {
      width: "100%",
    },
    searchBox: {
      flex: 1,
      minWidth: 0,
      maxWidth: "none",
      "& > *": {
        width: "100%",
      },
    },
    contentBox: {
      margin: 0,
    },
    tableFooter: {
      margin: 0,
    },
  },
}));
